import { AccountsAndProjectsMenu } from '../components/Menus/AccountsAndProjectsMenu';
import { BossControlsMenu } from '../components/Menus/BossControlsMenu';
import { NavigationMenu } from '../components/Menus/NavigationMenu';
import { NotificationsMenu } from '../components/Menus/NotificationsMenu/NotificationsMenu';
import { SettingsMenu } from '../components/Menus/SettingsMenu';

export enum SLIDER_MENUS {
  OPEN_ACCOUNTS_AND_PROJECTS = 'OPEN_ACCOUNTS_AND_PROJECTS',
  OPEN_BOSS = 'OPEN_BOSS',
  OPEN_CHAT = 'OPEN_CHAT',
  OPEN_NAVIGATION = 'OPEN_NAVIGATION',
  OPEN_NOTIFICATION_CENTER = 'OPEN_NOTIFICATION_CENTER',
  OPEN_QUICK_ACTIONS = 'OPEN_QUICK_ACTIONS',
  OPEN_SETTINGS = 'OPEN_SETTINGS',
  OPEN_SUPPORT = 'OPEN_SUPPORT',
}

export const NAV_SLIDER_RIGHT = {
  [SLIDER_MENUS.OPEN_ACCOUNTS_AND_PROJECTS]: AccountsAndProjectsMenu,
  [SLIDER_MENUS.OPEN_BOSS]: BossControlsMenu,
  [SLIDER_MENUS.OPEN_NOTIFICATION_CENTER]: NotificationsMenu,
  [SLIDER_MENUS.OPEN_SETTINGS]: SettingsMenu,
};

export const NAV_SLIDER_LEFT = {
  [SLIDER_MENUS.OPEN_NAVIGATION]: NavigationMenu,
};

export const NAV_SLIDER_MAP = {
  ...NAV_SLIDER_RIGHT,
  ...NAV_SLIDER_LEFT,
};
